import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=15cf965e&scoped=true&"
import script from "./o-header.vue?vue&type=script&lang=js&"
export * from "./o-header.vue?vue&type=script&lang=js&"
import style0 from "./o-header.vue?vue&type=style&index=0&id=15cf965e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf965e",
  null
  
)

export default component.exports